import React, { ComponentType } from 'react';
import styled from '@emotion/styled';
import { Flex, Box } from 'reflexbox';

import {
  MARKETING_PAGE_BREAKPOINT_TABLET,
  MARKETING_PAGE_BREAKPOINT_DESKTOP,
} from '../../../../components/Style/breakpoints';

import { FilteredCoursesProps } from './types';
import {
  MIXIN_COURSE_CARD_GRID,
  MIXIN_COURSE_CARD_GRID_TILE,
} from '../../../../components/Style/mixins';

const Top = styled(Flex)({
  position: 'relative',
  alignItems: 'center',
});

const Heading = styled.h1`
  font-family: Avenir;
  font-style: normal;
  font-weight: 900;
  font-size: 22px;
  line-height: 120%;
  color: #041416;
  margin: 0;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    font-size: 30px;
  }
`;

const FilteredCoursesContainer = styled(Flex)`
  justify-content: center;
  flex-direction: column;
  flex-grow: 1;
  width: 100%;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_TABLET}) {
    margin: 0 auto;
    // width: 1200px;
  }
`;

const CourseCardContainer = styled('div')({
  ...MIXIN_COURSE_CARD_GRID,
  marginTop: 20,
  width: '100%',
});

const ButtonsContainer = styled(Box)`
  display: none;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_TABLET}) {
    display: initial;
  }
`;

const LoadingContainer = styled('div')`
  display: flex;
  width: 100%;
  justify-content: center;
  margin-top: 25px;
`;

// TODO: This styling needs fixing because it's just overriding the existing ConnectedSortBySelector styles
const SortByButton = styled(Box)`
  display: inline-block;
  font-family: Avenir;
  font-style: normal;
  font-weight: 900;
  font-size: 16px;
  line-height: 120%;
  color: #000000;
  background: #ffffff;

  .olselector {
    margin-left: 12px;

    button {
      background: #ffffff;
      border: 1px solid #e5eaeb;
      border-radius: 64px;
      color: #3e4b4c;
      cursor: pointer;
      font-family: Avenir;
      font-weight: bold;
      font-size: 14px;
      outline: none;
      padding: 15px 47px 15px 32px;
      :hover {
        opacity: 0.9;
      }
    }

    .olselector-button::after {
      right: 27px;
    }

    .olselector-checkbox-label {
      font-family: Avenir;
      font-weight: normal;
      font-size: 14px;
    }

    .olselector-checkbox-label-selected {
      font-family: Avenir;
      font-weight: bold;
      font-size: 14px;
    }
  }
`;

export const FilteredCourses: ComponentType<FilteredCoursesProps> = ({
  courses,
  showMore,
  SortByComponent,
  CourseCardComponent,
  ShowMoreComponent,
  handleShowMoreClick,
}) => {
  const CourseCardTile = styled(CourseCardComponent)(
    MIXIN_COURSE_CARD_GRID_TILE
  );

  return (
    <FilteredCoursesContainer>
      <Top flexDirection="row" padding={12}>
        <Box flexGrow={1}>
          <Heading>Courses</Heading>
        </Box>
        <Flex alignItems="center">
          <ButtonsContainer>
            <SortByButton>
              Sort by:
              <SortByComponent />
            </SortByButton>
          </ButtonsContainer>
        </Flex>
      </Top>
      <CourseCardContainer>
        {courses.map((course) => {
          return (
            <CourseCardTile key={`coursecard-${course.path}`} {...course} />
          );
        })}
      </CourseCardContainer>
      <LoadingContainer>
        {showMore && (
          <ShowMoreComponent
            variant="primary"
            action={{
              kind: 'on_click',
              value: handleShowMoreClick,
            }}
          >
            Show more
          </ShowMoreComponent>
        )}
      </LoadingContainer>
    </FilteredCoursesContainer>
  );
};
